import { useTranslation } from "react-i18next"
import { useStyles } from "../styles"
import { Box, Checkbox, Icon, IconButton, List, ListItem, Tooltip, Typography } from "@mui/material"
import { HeaderRowCheckBox } from "../../../../../../calendar/pages/main/components/headerRowCheckBox"
import { icons } from "../../../../../../../utils/icons"
import { ItemMenu } from "../../../../../../questionnaire/pages/main/typing/types"
import { menuItems, menuListFiles } from "../constans/menu"
import { Dispatch, SetStateAction, useEffect, useRef, useState } from "react"
import { Constants } from "../../../../../../../utils/constants"
import { Roles, Status } from "../../../../../../../utils/enums"
import StatusComponent from "../../../../../../../components/status"
import { getStatus } from "../../../../../../../hooks/status"
import { useContextState } from "../../../../../../../hooks/theme"
import { FilterBody } from "../../../../../../../hooks/filter/typing"
import { filesManagerServiceFetch } from "../../../../../../../utils/constants/callService"
import { returnQuery, returnQueryWithPagination } from "../../../../../../../utils/methods/returnQuery"
import { formData } from "../constans/format"
import { formatFilesList } from "../../../../../../../service/filesManager/format"
import { RowItem } from "../../../../../../../service/filesManager/response"
import { getLocalStorage } from "../../../../../../../utils/crud/crypt"
import { MenuOptionFileManager } from "../../../../../utils/enums/menu"
import { DownloadType } from "../../../../../../../hooks/download/useDownload"

const useTable = ({
    isChecked,
    notFileSelected,
    selectedIds,
    setNotFileSelected,
    setSelectedIds,
    setIsChecked,
    filterFileMain,
    getDetailInform,
    uuid
}: {
    setIsChecked: Dispatch<SetStateAction<boolean>>,
    selectedIds: number[], isChecked: boolean,
    setSelectedIds: Dispatch<SetStateAction<number[]>>,
    notFileSelected: number[],
    setNotFileSelected: Dispatch<SetStateAction<number[]>>,
    filterFileMain: FilterBody;
    getDetailInform: ({ query, type }: {
        query?: string;
        type?: DownloadType;
    }) => Promise<void>;
    uuid: string;
}) => {

    const { t } = useTranslation()
    const styles = useStyles()
    const { colors } = useContextState()
    const [tableLoading, setTableLoading] = useState(false)
    const refTime = useRef<NodeJS.Timeout | null>(null)
    const [totalPages, setTotalPages] = useState(0)
    const state: { id: number, role: number } = getLocalStorage()


    const [detail, setDetail] = useState<{
        id: number
        positionMenu: Record<string, unknown>
        anchor: null | HTMLButtonElement
        menu: ItemMenu[]
    }>({
        id: 0,
        positionMenu: {},
        anchor: null,
        menu: menuItems,
    })

    const handleHeaderChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setSelectedIds([]);
        setNotFileSelected([]);
        if (event.target.checked) {
            setIsChecked(true)
        } else {
            setIsChecked(false)
        }
    };

    const [row, setRow] = useState<RowItem[]>([])

    const getFilesList = async () => {
        setTableLoading(true)
        const response = await filesManagerServiceFetch.getListFiles({ query: returnQuery({ ...filterFileMain.query, filter: filterFileMain.query.filter?.replaceAll('+', '%2B') }, formData) })
        const { row } = formatFilesList({ response })

        if (!response?.errors) {
            setRow(row)
            setTotalPages(response.totalPages)
        }

        setTableLoading(false)
    }

    useEffect(() => {
        if (refTime.current) { clearTimeout(refTime.current) }

        refTime.current = setTimeout(() => {
            getFilesList()
            setSelectedIds([]);
            setNotFileSelected([]);
            setIsChecked(false)
        }, 300)
    }, [filterFileMain.query.all])

    const queryv2 = returnQueryWithPagination({ filter: filterFileMain.filterString, sort: filterFileMain.query?.sort, }).replace('&', '')

    const downloadCustomePdf = () => {
        getDetailInform({ query: queryv2, type: 'pdf' })
    }

    const downloadCustomeWord = () => {
        getDetailInform({ query: queryv2, type: 'word' })
    }

    const downloadCustomeExcel = () => {
        getDetailInform({ query: queryv2, type: 'excel' })
    }

    useEffect(() => {
        if (uuid) {
            const interval = setInterval(() => {
                getDetailInform({ query: queryv2 });
            }, 30000);
            return () => clearInterval(interval);
        }
    }, [uuid])

    const column = [
        {
            field: 'checkbox',
            headerName: '',
            headerCell: styles?.mineHeaderTable,
            label: (
                <Checkbox
                    checked={isChecked}
                    onChange={handleHeaderChange}
                    color="primary"
                />
            ),
            renderCell: (params: any) => {
                //const validation = !!(params.row.createById !== state.id) && state.role !== Roles.ADMIN
                const isMine = params.row.createdBy == state.id
                const isMineOrAdmin = params.row.createdBy == state.id || state.role == Roles.ADMIN
                return (<>
                    {isMineOrAdmin &&
                        <Box sx={styles.flex}>
                            <HeaderRowCheckBox
                                id={params.row.id}
                                isChecked={isChecked}
                                selectedIds={selectedIds}
                                setSelectedIds={setSelectedIds}
                                notFolioSelected={notFileSelected}
                                setNotFolioSelected={setNotFileSelected}
                                disabled={false}
                            />

                            {isMine &&
                                <Tooltip title={t('filesManager.titles.mineFile')}>
                                    <Box sx={styles.circle} />
                                </Tooltip>
                            }
                        </Box>
                    }
                </>)
            }
        },
        {
            id: 'area',
            label: t('filesManager.columns.area'),
            headerCell: styles?.headerTable,
            renderCell: (params: any) => {
                const areaArray = params.row.area ? params.row.area : undefined;
                const firstTwoArea = areaArray?.slice(0, 2);
                const remainingArea = areaArray?.slice(2);
                return (
                    <Box /* sx={styles.containerArea} */>
                        <Typography sx={styles.areaTitle}>
                            {firstTwoArea?.join(', ')}
                            {remainingArea?.length > 0 && (
                                <Tooltip
                                    title={
                                        <List>
                                            {remainingArea.map((item: string, index: number) => (
                                                <ListItem key={index} style={{ padding: 0 }}>
                                                    {item}
                                                </ListItem>
                                            ))}
                                        </List>
                                    }
                                >
                                    <Icon sx={styles.viewMore}>{icons('add')}</Icon>
                                </Tooltip>
                            )}
                            {!areaArray.length && 'N/A'}
                        </Typography>
                    </Box>
                )
            },
        },
        {
            id: 'department',
            label: t('filesManager.columns.department'),
            headerCell: styles?.headerTable,
            renderCell: (params: any) => {
                const departmentArray = params.row.department ? params.row.department : undefined;
                const firstTwoDepartment = departmentArray?.slice(0, 2);
                const remainingDepartment = departmentArray?.slice(2);
                return (
                    <Box /* sx={styles.containerArea} */>
                        <Typography sx={styles.areaTitle}>
                            {firstTwoDepartment?.join(', ')}
                            {remainingDepartment?.length > 0 && (
                                <Tooltip
                                    title={
                                        <List>
                                            {remainingDepartment.map((item: string, index: number) => (
                                                <ListItem key={index} style={{ padding: 0 }}>
                                                    {item}
                                                </ListItem>
                                            ))}
                                        </List>
                                    }
                                >
                                    <Icon sx={styles.viewMore}>{icons('add')}</Icon>
                                </Tooltip>
                            )}
                            {!departmentArray.length && 'N/A'}
                        </Typography>
                    </Box>
                )
            },
        },
        {
            id: 'fileName',
            label: t('filesManager.columns.fileName'),
            headerCell: styles?.headerTable,
            sortable: true
        },
        {
            id: 'createTime',
            label: t('filesManager.columns.creationDate'),
            headerCell: styles?.headerTable,
            sortable: true
        },
        {
            id: 'solicitedUsers',
            label: t('filesManager.columns.solicitedUsers'),
            headerCell: styles?.headerTable,
            //sortable: true,
            renderCell: (params: any) => {
                const usersArray = params.row.solicitedUsers ? params.row.solicitedUsers : undefined;
                const firstTwoUsers = usersArray?.slice(0, 1);
                const remainingUsers = usersArray?.slice(1);
                return (
                    <Box /* sx={styles.containerArea} */>
                        <Typography sx={styles.areaTitle}>
                            {firstTwoUsers?.join(', ')}
                            {remainingUsers?.length > 0 && (
                                <Tooltip
                                    title={
                                        <List>
                                            {remainingUsers.map((item: string, index: number) => (
                                                <ListItem key={index} style={{ padding: 0 }}>
                                                    {item}
                                                </ListItem>
                                            ))}
                                        </List>
                                    }
                                >
                                    <Icon sx={styles.viewMore}>{icons('add')}</Icon>
                                </Tooltip>
                            )}
                            {!usersArray.length && 'N/A'}
                        </Typography>
                    </Box>
                )
            },
        },
        {
            id: 'type',
            label: t('filesManager.columns.type'),
            headerCell: styles?.headerTable,
            //sortable: true
        },
        {
            id: 'size',
            label: t('filesManager.columns.size'),
            headerCell: styles?.headerTable,
            sortable: true
        },
        {
            id: 'status',
            label: t('filesManager.columns.status'),
            headerCell: styles?.headerTable,
            //sortable: true,
            renderCell: (params: any) => {
                const status = getStatus(params?.row?.status as Status == Status.CLOSE ? Status.CANCEL : params?.row?.status, colors, t,)
                return (
                    <StatusComponent color={status.color} msg={status.text} size='small' />
                )
            }
        },
        {
            id: 'action',
            label: t('filesManager.columns.action'),
            minWidth: 50,
            renderCell: (params: any) => {
                const id = params?.row?.id
                const isMineOrAdmin = params.row.createdBy == state.id || state.role == Roles.ADMIN
                const status = params.row.status
                return (
                    <Box sx={styles.containerStatus}>
                        <Tooltip title={t('ToolTips.seeActions')}>
                            <IconButton
                                onClick={(e) => {
                                    let menu: ItemMenu[];

                                    if (isMineOrAdmin) {
                                        menu = menuItems.filter(item =>
                                            menuListFiles[status as Status]?.includes(item.value)
                                        );
                                    } else {
                                        menu = menuItems.filter(item => item.value === MenuOptionFileManager.SEE_DETAIL_FILE);
                                    }

                                    setDetail({
                                        id,
                                        positionMenu:
                                            row?.length < Constants.numberOfRows
                                                ? {
                                                    top: 0,
                                                    left: '-30px',
                                                }
                                                : {
                                                    top: `${e.clientY}px`,
                                                    left: `${e.clientX - 120}px`,
                                                },
                                        anchor: e.currentTarget,
                                        menu: menu,
                                    })
                                }}
                            >
                                {icons('moreHoriz')}
                            </IconButton>
                        </Tooltip>
                    </Box>
                )
            },
        },
    ]


    return { getFilesList, column, row, detail, setDetail, tableLoading, totalPages, downloadCustomePdf, downloadCustomeWord, downloadCustomeExcel }
}



export { useTable }